import React from 'react'
import { NavLink } from 'react-router-dom'
import { Tooltip } from '@material-ui/core'
import {
  PowerSettingsNew,
  SettingsOutlined,
  HelpOutline,
} from '@material-ui/icons'
import { API } from '../../config'
import { StyledActionWrapper, StyledIconButton } from './styled'
import { UserProfileButton } from './UserProfileButton'

export interface IHeaderActions {
  displaySettingsIcon: boolean
  overlayIsShown: boolean
  handleLogout: () => void
}

export const HeaderActions = ({
  displaySettingsIcon,
  overlayIsShown,
  handleLogout,
}: IHeaderActions) => {
  return (
    <StyledActionWrapper>
      {displaySettingsIcon && (
        <StyledIconButton
          id="settings-page"
          component={(routerProps) => (
            <NavLink
              to="/settings/groups?tab=groups"
              isActive={(_, { pathname }) => pathname.startsWith('/settings')}
              {...routerProps}
            />
          )}
        >
          <SettingsOutlined />
        </StyledIconButton>
      )}
      {/* eslint-disable jsx-a11y/anchor-has-content */}
      <Tooltip title="Help">
        <StyledIconButton
          id="link-to-help"
          component={(routerProps) => (
            <a
              href={API.HELP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              {...routerProps}
            />
          )}
        >
          <HelpOutline />
        </StyledIconButton>
      </Tooltip>
      <UserProfileButton/>
      {/* eslint-enable */}
      <Tooltip title="Logout">
        <StyledIconButton id="logout-dialog" onClick={handleLogout}>
          <PowerSettingsNew />
        </StyledIconButton>
      </Tooltip>
    </StyledActionWrapper>
  )
}
